import * as React from "react";
import { Query, QueryResult } from "react-apollo";
import { GetMailingListsQuery } from "../../__generated__/types";
import { MAILING_LISTS_QUERY } from "./queries";

export class MailingListsQuery extends Query<GetMailingListsQuery> {}

interface Props {
  children(props: QueryResult<GetMailingListsQuery>): React.ReactNode;
}

export default ({ children }: Props) => {
  return (
    <MailingListsQuery query={MAILING_LISTS_QUERY}>
      {result => children(result)}
    </MailingListsQuery>
  );
};



// WEBPACK FOOTER //
// ./src/queries/MailingListsQuery/MailingListsQuery.tsx